import React from "react";

export const useLogin = () => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  // const [error, setError] =

  const changeEmailHandler = (val) => setEmail(val);
  const changePasswordHandler = (val) => setPassword(val);

  return { email, password, changeEmailHandler, changePasswordHandler };
};
